export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Home",
    reservations: "Prenotazioni",
    calendar: "Calendario",
    hourlyCalendar: "A ore",
    calls: "Chiamate",
    aiReception: "Reception IA",
    availabilityRates: "Disponibilità e tariffe",
    checkins: "Check-in",
    channels: "Canali di prenotazione",
    inbox: "Inbox",
    settings: "Impostazioni",
    experiences: "Esperienze",
    scheduleCall: "Prenota una chiamata",
    support: "Assistenza",
    novedades: "Novità",
    messages: "Messaggi",
    badgeNew: "Nuovo",
    invoicing: "Fatturazione",
    customers: "Clienti",
    clientsDirectory: "Clienti",
    fiscalCustomers: "Clienti fiscali",
    invoices: "Fatture",
    housekeeping: "Pulizie",
    analytics: "Statistiche",
  },
  alt: {
    logo: "Logo",
  },
};
